import Link from '@/lib/nav/link';

/**
 * Inline placeholder rendered in place of the Clerk `<SignIn>` /
 * `<SignUp>` widgets when NEXT_PUBLIC_DEV_AUTH_BYPASS is on. The real
 * widgets need Clerk JS, which a sandboxed preview browser can't
 * reach — without this, /login and /signup would crash in bypass mode.
 */
export function DevBypassAuthPlaceholder() {
  return (
    <div className="rounded-md border border-dashed border-amber-500/60 bg-amber-50 p-5 text-sm leading-6 text-amber-900">
      <p className="font-bold">Dev auth bypass active.</p>
      <p className="mt-1 text-amber-900/85">
        Clerk sign-in/sign-up is disabled in this preview session. Use a regular browser to test the
        real auth flow.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <Link
          href="/new-trip"
          className="inline-flex h-9 items-center justify-center rounded-full bg-amber-900 px-4 text-xs font-bold uppercase tracking-wide text-amber-50 transition hover:bg-amber-950"
        >
          Open the app
        </Link>
        <Link
          href="/"
          className="inline-flex h-9 items-center justify-center rounded-full border border-amber-900/30 px-4 text-xs font-bold uppercase tracking-wide text-amber-900 transition hover:border-amber-900/60"
        >
          Marketing home
        </Link>
      </div>
    </div>
  );
}
